<template>
  <div class="order-error">
    <p class="bold">Subscription e-mail could not be send.</p>
    <span
      >Please send your <span class="bold">Digital-Order-ID</span> to
      <span class="bold">support@solar-fox.com</span> with the request to resend
      the e-mail.</span
    >
  </div>
</template>

<script>
export default {
  name: "order-error-view",
  props: {
    title: String,
  },
  components: {},
  computed: {},
  methods: {},
};
</script>

<style scoped>
.order-error {
  margin-top: 30px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: red;
  border: 1px solid red;
  padding: 20px;
  border-radius: 3px;
}

.bold {
  font-weight: bold;
}
</style>
